// Local business types (niches) offered as suggestions in the
// Market Report landing form. Every entry corresponds to a Google
// Business Profile (formerly Google My Business / GMB) category so
// the downstream Market Report pipeline can reliably pull GMB data
// for the buyer's chosen vertical.
//
// Curated to be broad enough that ~95% of buyers find their exact
// business in the dropdown, while staying focused on local
// service / brick-and-mortar verticals where a Localytics market
// report is most useful.

export const BUSINESS_TYPES = [
  "Acupuncture Clinic",
  "Appliance Repair",
  "Architect",
  "Assisted Living Facility",
  "Auto Body Shop",
  "Auto Dealer",
  "Auto Detailing",
  "Auto Glass Repair",
  "Auto Repair Shop",
  "Bakery",
  "Bar",
  "Barber Shop",
  "Bed and Breakfast",
  "Boat Dealer",
  "Bookkeeping Service",
  "Boutique",
  "Brewery",
  "Bridal Shop",
  "Cabinet Maker",
  "Cafe",
  "Car Wash",
  "Carpenter",
  "Carpet Cleaning",
  "Catering",
  "Chiropractor",
  "Cleaning Service",
  "Coffee Shop",
  "Computer Repair",
  "Concrete Contractor",
  "Construction Company",
  "CrossFit Gym",
  "Daycare / Childcare",
  "Dance Studio",
  "Deck Builder",
  "Dentist",
  "Dermatologist",
  "DJ Service",
  "Dog Boarding",
  "Dog Grooming",
  "Dog Trainer",
  "Driving School",
  "Dry Cleaner",
  "Electrician",
  "Estate Planning Attorney",
  "Event Venue",
  "Eyelash Extensions",
  "Family Law Firm",
  "Fence Contractor",
  "Financial Advisor",
  "Fitness Trainer",
  "Florist",
  "Food Truck",
  "Funeral Home",
  "Furniture Store",
  "Garage Door Service",
  "General Contractor",
  "Gun Store",
  "Gutter Cleaning",
  "Gym",
  "Hair Salon",
  "Handyman",
  "Hardware Store",
  "Home Inspector",
  "Hotel",
  "House Painter",
  "HVAC",
  "Ice Cream Shop",
  "Insurance Agency",
  "Interior Designer",
  "Jewelry Store",
  "Junk Removal",
  "Kitchen Remodeler",
  "Landscaping",
  "Law Firm",
  "Lawn Care",
  "Locksmith",
  "Martial Arts School",
  "Massage Therapy",
  "Mattress Store",
  "Med Spa",
  "Mortgage Broker",
  "Motel",
  "Motorcycle Dealer",
  "Moving Company",
  "Music School",
  "Nail Salon",
  "Notary Public",
  "Optometrist",
  "Orthodontist",
  "Personal Injury Lawyer",
  "Pest Control",
  "Pet Store",
  "Pharmacy",
  "Phone Repair",
  "Photography Studio",
  "Physical Therapy",
  "Pilates Studio",
  "Pizza Restaurant",
  "Plastic Surgery",
  "Plumbing",
  "Pool Cleaning",
  "Pool Installer",
  "Pressure Washing",
  "Print Shop",
  "Property Management",
  "Real Estate Agency",
  "Restaurant",
  "Roofing",
  "RV Dealer",
  "Septic Service",
  "Sign Shop",
  "Solar Installer",
  "Spa",
  "Storage Facility",
  "Sushi Restaurant",
  "Tanning Salon",
  "Tattoo Shop",
  "Tax Preparation",
  "Tire Shop",
  "Towing Service",
  "Tree Service",
  "Tutoring Center",
  "Used Car Dealer",
  "Veterinarian",
  "Videographer",
  "Wedding Photographer",
  "Wedding Planner",
  "Wedding Venue",
  "Window Cleaning",
  "Window Installation",
  "Yoga Studio",
];

// Returns up to `limit` business types matching the given query.
// Matches that begin with the query are listed before substring matches.
export function searchBusinessTypes(query, limit = 8) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return [];

  const startsWith = [];
  const contains = [];
  for (const type of BUSINESS_TYPES) {
    const lower = type.toLowerCase();
    if (lower.startsWith(q)) {
      startsWith.push(type);
    } else if (lower.includes(q)) {
      contains.push(type);
    }
    if (startsWith.length >= limit) break;
  }
  return [...startsWith, ...contains].slice(0, limit);
}

export default BUSINESS_TYPES;
